import { defineComponent as _defineComponent } from 'vue'
import {
  Modal,
  HeadingDisplay,
  ContentDisplay,
  ListDisplay
} from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface ITradeValues {
  label: string;
  value: string;
}

interface Props {
  isOpen: boolean;
  isNegativeTransitAmount: boolean;
  transitAmount: string;
  wealthProjectedAmount: string;
  tradeTotalValue: string;
  tradeValues: ITradeValues[];
}

interface EmitEvents {
  (event: 'close'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TransitModal',
  props: {
    isOpen: { type: Boolean },
    isNegativeTransitAmount: { type: Boolean },
    transitAmount: null,
    wealthProjectedAmount: null,
    tradeTotalValue: null,
    tradeValues: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {





function emitClose() {
  emit('close');
}

return { __sfc: true,emit, emitClose, Modal, HeadingDisplay, ContentDisplay, ListDisplay, Portal, NebraskaColors }
}

})